import { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useQuery } from '@tanstack/react-query';
import apiClient from '../../api/axios';
import { Spin } from 'antd';

interface RecaptchaFieldProps {
    value?: string;
    onChange?: (token: string | null) => void;
}

export const RecaptchaField = forwardRef<ReCAPTCHA, RecaptchaFieldProps>(({ onChange }, ref) => {
    const { data: siteKey, isLoading } = useQuery({
        queryKey: ['publicSettings', 'recaptchaSiteKey'],
        queryFn: async () => {
            const response = await apiClient.get('/public/site-settings');
            return response.data.data.siteTokens?.RecaptchaSiteKey;
        },
        staleTime: 1000 * 60 * 60, // 1 hour
    });

    if (isLoading) {
        return <Spin size="small" />;
    }

    if (!siteKey) {
        return null; // reCAPTCHA not configured
    }

    return (
        <ReCAPTCHA
            ref={ref}
            sitekey={siteKey}
            size="invisible"
            onChange={(token) => onChange?.(token)}
            className="mb-4"
        />
    );
});

RecaptchaField.displayName = 'RecaptchaField';
